import * as React from "react";
import ViewBlockAsset from "@warda/library-ui/layout/ViewBlockAsset";
import AssetExtension from "@warda/library-ui/core/AssetExtension";
import { isMobile } from "@warda/library-ui/utils/deviceUtils";
import { useAppMediaTypeCtx } from "@warda/library-ui/contexts/AppMediaTypeContext";
import { getAssetPropsMedia } from "../utils";
import { useContextDispatchViewport } from "../../SharePage";
import getSPPreviewSrcUrl from "../../../../utils/getSPPreviewSrcUrl";
import getSPVideoPreviewUrls from "../../../../utils/getSPVideoPreviewUrls";
const hTitle = 50;
const margin = 10;
const sPreview = isMobile() ? 140 : 200;
export const blockHeightMedia = hTitle + margin * 3 + sPreview;
const ViewBlockAssetMedia = ({ id, color, size, data, selected, selectedIds, contextmenuOriginAnchor, contextmenuOriginTransf, contextmenuPosizionZone, onContextMenu, }) => {
    const dispatchViewport = useContextDispatchViewport();
    const appMediaTypeCtx = useAppMediaTypeCtx();
    const { fileId, mimeType, renditions } = data;
    const props = getAssetPropsMedia({
        dispatchViewport,
        color,
        id,
        data,
        selected,
        selectedIds,
        onContextMenu,
        contextmenuOriginAnchor,
        contextmenuOriginTransf,
        contextmenuPosizionZone,
        mimeTypeToMediaKind: appMediaTypeCtx.mimeTypeToMediaKind,
    });
    return (React.createElement(ViewBlockAsset, { ...props, width: size[0] - margin * 2, preview: {
            previewWidth: sPreview,
            previewHeight: sPreview,
            srcUrl: getSPPreviewSrcUrl({
                fileId,
                size: 2,
                mimeType,
                mimeTypeToMediaKind: appMediaTypeCtx.mimeTypeToMediaKind,
            }),
            ...getSPVideoPreviewUrls({
                fileId,
                renditions,
                mimeType,
                mimeTypeToMediaKind: appMediaTypeCtx.mimeTypeToMediaKind,
            }),
            mimeType,
            placeholderIcon: props.icon,
        } },
        React.createElement(AssetExtension, { mimeType: mimeType, style: { position: "absolute", bottom: 10, right: 10 } })));
};
export default ViewBlockAssetMedia;
